export default __webpack_public_path__ + "static/media/calendar.c1f1465e.png";